module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4yvabW/tc-custom/9781398422384.jpg?1674929446178",
      "alt": "This image is the cover for the book The Warriors Twelve - Book 2"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Warriors Twelve - Book 2\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Warriors Twelve are back with more, continuing on from where we left off before. You already met Moo and Wotalot in book one. Now it is time for you to meet Mum. ‘Trojan’ Wotalot’s pet staffy makes his appearance, Wotalot’s friends discuss ‘The School In The Distance’. Rumours begin to surface as rumours often do, Wotalot wonders if any of these stories are true. Mum is busy with all kinds of things; she has organised a get together to see what it brings. Wotalot speaks of thoughts that pass through his mind, Moo enjoys these conversations at any time. As always, there is music woven into the plot, it goes without saying, it goes with ‘The Lot’. Which warrior do you relate to? You are one without a doubt. Do you see yourselfin all of them? In time you will figure it out. With so much to discover, so much to take in, best open the book now and journey within.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jeanine AuVache\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Born in Essex, Jeanine AuVache knew at a young age that she had returned to a future time. Her love for the woods and magic ‘inside’ was alive once more. She knew her mission was to find the family who understood what she saw and heard in her mind. Her purpose was to unlock cages and hearts. Over time it became apparent that she was alone in the woods and music became her faithful companion. One day her world was to turn WRITE side UP. Her wish is that her stories reach others who may be wandering and wondering ‘out there’.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0